// -------------------- Vue 核心与根组件 --------------------
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './components/store'

// -------------------- 第三方插件 --------------------
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import moment from 'moment'
import _ from 'lodash'
import echarts from 'echarts'
import axios from 'axios'

// -------------------- 样式资源 --------------------
import './assets/fonts/iconfont.css'
import './assets/css/global.css'

// -------------------- 插件注册与初始化 --------------------
import './plugins/element.js'

// 设置 moment 为中文语言环境
moment.locale('zh-cn')

// -------------------- 全局属性挂载 --------------------
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$_ = _
Vue.prototype.$http = axios

// 使用 ElementUI 插件
Vue.use(ElementUI)
Vue.prototype.$message = ElementUI.Message

// -------------------- Axios 全局配置 --------------------
axios.defaults.baseURL = '/api'
// axios.defaults.baseURL = 'https://gyfcdyjq.cn:10001' // 默认请求地址
// axios.defaults.baseURL = 'http://8.138.133.198:10001' // 生产请求地址
axios.defaults.timeout = 15000

// 请求拦截器：正确设置 Token
axios.interceptors.request.use(function(config) {
  NProgress.start()

  // 直接从 sessionStorage 获取 token
  var token = sessionStorage.getItem('token')

  if (token) {
    // 确保 token 以 'Bearer ' 开头
    if (token.indexOf('Bearer ') !== 0) {
      token = 'Bearer ' + token
    }
    config.headers.Authorization = token
  }

  return config
}, function(error) {
  NProgress.done()
  return Promise.reject(error)
})

// 响应拦截器：统一处理异常、登录过期、关闭进度条
axios.interceptors.response.use(function(response) {
  NProgress.done()
  return response
}, function(error) {
  NProgress.done()

  // 处理 401 认证错误
  if (error.response && error.response.status === 401) {
    var message = '认证失败，请重新登录'
    if (error.response.data && error.response.data.message) {
      message = error.response.data.message
    }
    Vue.prototype.$message.error(message)

    // 清除过期信息
    sessionStorage.clear()
    store.dispatch('globalUserInfo/logout')

    // 跳转到登录页
    if (router.currentRoute.path !== '/login') {
      router.push('/login')
    }
  } else if (error.response && error.response.data && error.response.data.code !== undefined) {
    var code = error.response.data.code
    var errMsg = error.response.data.message

    // 认证错误处理
    if (code === 40102 || code === 99999) {
      var tipMsg = code === 40102 ? '登录状态已过期，请重新登录' : (errMsg || '认证失败')
      Vue.prototype.$message.error(tipMsg)
      store.dispatch('globalUserInfo/logout')
      if (router.currentRoute.path !== '/login') {
        router.push({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
      }
    }
  }

  return Promise.reject(error)
})

// -------------------- 全局过滤器 --------------------
Vue.filter('dateFormat', function(originVal) {
  if (!originVal) return ''
  var dt = new Date(originVal)
  var y = dt.getFullYear()
  var m = String(dt.getMonth() + 1).padStart(2, '0')
  var d = String(dt.getDate()).padStart(2, '0')
  var hh = String(dt.getHours()).padStart(2, '0')
  var mm = String(dt.getMinutes()).padStart(2, '0')
  var ss = String(dt.getSeconds()).padStart(2, '0')
  return y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss
})

// -------------------- Vue 实例创建 --------------------
new Vue({
  store: store,
  router: router,
  render: function(h) { return h(App) }
}).$mount('#app')
